import { useMemo } from 'react';
import { useDataFetchingClient } from 'data-fetching-client';
import { readFoldersCache } from 'framework-listing-lib/internal/Folders/utils/cache';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import useUnfiledAssetsName from 'framework-listing-lib/internal/Folders/hooks/useUnfiledAssetsName';
import { UNFILED_ASSETS_ID } from 'framework-listing-lib/internal/Folders/constants/folders';
export default function useGetInitialFolderName({
  folderId,
  openFoldersMap,
  skip
}) {
  const client = useDataFetchingClient();
  const objectTypeId = useObjectTypeId();
  const unfiledAssetName = useUnfiledAssetsName();
  return useMemo(() => {
    if (skip) {
      return undefined;
    }
    if (folderId === UNFILED_ASSETS_ID || folderId === 0 || !folderId) {
      return unfiledAssetName;
    }
    if (!Object.keys(openFoldersMap).length) {
      return undefined;
    }
    const folderName = null;
    const parentFolderId = Object.keys(openFoldersMap).find(key => openFoldersMap[key].includes(folderId));
    if (!parentFolderId) {
      return folderName;
    }
    const folderCache = readFoldersCache(client.cache, {
      objectType: objectTypeId,
      parentFolderId: parseInt(parentFolderId, 10)
    });
    if (!folderCache) {
      return folderName;
    }
    const currentFolder = folderCache.getFolders.find(folder => folder.objectId === folderId);
    const cacheFolderName = currentFolder && getPropertyValue(currentFolder, 'hs_name');
    return cacheFolderName !== undefined ? cacheFolderName : unfiledAssetName;
  }, [client.cache, folderId, objectTypeId, openFoldersMap, skip, unfiledAssetName]);
}